import React from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

const AdminContactForm = () => {
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-12 col-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">All Contact Forms</h5>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row p-2">
                      <div className="col-md-4">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search By Name"
                        />
                      </div>
                    </div>
                    <div
                      className="table-responsive"
                      style={{ scrollbarWidth: "thin" }}
                    >
                      <table className="table table-striped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Message</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>Komal zawar </td>
                            <td>Komalzawar22@gmail.com</td>
                            <td>Test mail</td>
                            <td>
                              <button
                                className="btn btn-primary btn-sm"
                                data-bs-toggle="modal"
                                data-bs-target="#viewreplayModal"
                              >
                                View/Replay
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>Komal zawar </td>
                            <td>Komalzawar22@gmail.com</td>
                            <td>Test mail</td>
                            <td>
                              <button
                                className="btn btn-primary btn-sm"
                                data-bs-toggle="modal"
                                data-bs-target="#viewreplayModal"
                              >
                                View/Replay
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>Komal zawar </td>
                            <td>Komalzawar22@gmail.com</td>
                            <td>Test mail</td>
                            <td>
                              <button
                                className="btn btn-primary btn-sm"
                                data-bs-toggle="modal"
                                data-bs-target="#viewreplayModal"
                              >
                                View/Replay
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>Komal zawar </td>
                            <td>Komalzawar22@gmail.com</td>
                            <td>Test mail</td>
                            <td>
                              <button
                                className="btn btn-primary btn-sm"
                                data-bs-toggle="modal"
                                data-bs-target="#viewreplayModal"
                              >
                                View/Replay
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>Komal zawar </td>
                            <td>Komalzawar22@gmail.com</td>
                            <td>Test mail</td>
                            <td>
                              <button
                                className="btn btn-primary btn-sm"
                                data-bs-toggle="modal"
                                data-bs-target="#viewreplayModal"
                              >
                                View/Replay
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between">
                      <p className="text-dark">Showing 1 to 3 of 20 entries</p>
                      <nav aria-label="...">
                        <ul className="pagination">
                          <li className="page-item disabled">
                            <a className="page-link" href="#" tabindex="-1">
                              Previous
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              1
                            </a>
                          </li>
                          <li className="page-item active">
                            <a className="page-link" href="#">
                              2 <span className="sr-only">(current)</span>
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              3
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              Next
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminContactForm;
